export default "__VITE_ASSET__q2$ENAa0__"